import { Box, Button } from "@mui/material";
import { useTheme } from "../../../../../context/themeContext";
import styles from "./style.module.css";
import { useNavigate } from "react-router-dom";

const HWC = () => {
  const { theme, darkMode } = useTheme();
  const navigate = useNavigate();

  return (
    <Box className={styles.help}>
      <Button
        variant="text"
        onClick={() => navigate("/help-with-classification")}
        sx={{
          color: darkMode
            ? theme.palette.secondary.blue300
            : theme.palette.secondary.dark,
          textDecoration: "underline",
          fontSize: "14px",
          textTransform: "capitalize",
        }}
      >
        Need help with your classifications?
      </Button>
    </Box>
  );
};

export default HWC;
